// extracted by mini-css-extract-plugin
export default {"page":"page-l99g","splitview":"splitview-Bz0y","s":"s-mOzo","r":"r-JslL","f":"f-fEyX"};